module.exports = __webpack_public_path__ + "static/media/5euro.5ce7f086.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/coupures/5euro.jpg
// module id = 929
// module chunks = 0